import React, { PropsWithChildren } from "react";
import cn from "classnames";

import "./Tooltip.css";

export enum Direction {
    TOP = "top",
    BOTTOM = "bottom"
}

interface Props {
    text: string;
    direction?: Direction;
    className?: string;
    type?: "default" | "dark";
    wide?: boolean;
    visible?: boolean;
    delay?: boolean;
}

const Tooltip: React.FC<Props> = function Tooltip({
    text,
    direction,
    className,
    type,
    wide,
    visible,
    delay,
    children
}: PropsWithChildren<Props>) {
    type = type || "default";

    const classPerType = {
        default: "",
        dark: "dark"
    };

    const classes = cn(
        "tooltip__text",
        delay ? "tooltip__text--delay" : "tooltip__text--nodelay",
        direction ? direction : "top",
        className,
        classPerType[type],
        { visible: visible, wide: wide }
    );

    if (children) {
        return (
            <div className="tooltip">
                {children}
                <div className={classes}>{text}</div>
            </div>
        );
    } else {
        return <div className={classes}>{text}</div>;
    }
};

export default Tooltip;
